// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UI4ww","left":"styles_left__2Epua"};